import {
  Row,
  Col,
  Input,
  Steps,
  message,
  Button,
  Modal,
  Form,
} from "antd";
import { useState, useRef } from "react";
import CustomerGridItem from "../../components/CustomerGrid";
import PersianDatePicker from "../../components/PersianDatePicker";
import Widget from "../../components/Widget";
import NewPayment from "./newPayment";
import { PlusOutlined } from "@ant-design/icons";
import Classes from "./index.module.css";
import "./receive.css";

const Search = Input.Search;
const Step = Steps.Step;
const FormItem = Form.Item;

export default function Payment() {
  const dateRef = useRef();

  const customer1 = [];
  for (let i = 1; i < 101; i++) {
    customer1.push({
      name: "مشتری " + i,
      id: i,
      address: "آدرس " + i,
      tel: "32598748",
      phone: "09140985672",
      cashBalance: null,
      chequeBalance: "3000",
      maxOpeninvoices: "3",
      maxDaysForCheque: "5",
      cashAccountBalance: "50000",
      status: Math.floor(Math.random() * 1),
      invoiceCount: 3,
      chequeAccountBalance: 12,
      btn: {
        title: "ثبت درخواست",
        action: () => {
          const curr = currentPage.current + 1;
          setCurrentPage({ current: curr });
        },
      },
    });
  }

  const [currentPage, setCurrentPage] = useState({ current: 0 });
  const [customers, setCustomers] = useState(customer1);
  const [displayedCustomers, setDisplayedCustomers] = useState(customers);

  const onSearch = (value, _e, info) => {
    const cu = customers.filter((i) => {
      if (
        i.name.toString().includes(value) ||
        i.id.toString().includes(value)
      ) {
        return i;
      }
    });
    setDisplayedCustomers(cu);
  };

  const steps = [
    {
      key: 1,
      title: "اول",
      content: (
        <>
          <Row className={Classes.searchForm}>
            <Search
              placeholder="جستوجو نام و کد"
              onSearch={onSearch}
              allowClear
              enterButton
            />
          </Row>
          <Row>
            {displayedCustomers.map((i) => {
              return (
                <Col span={24}>
                  <CustomerGridItem {...i} />
                </Col>
              );
            })}
          </Row>
        </>
      ),
    },
    {
      key: 2,
      title: "دوم",
      content: (
        <>
          <Row className={Classes.searchForm}>
            <Button
              type="default"
              className={Classes.nextBtn}
              shape="circle"
              size="large"
              onClick={() => {
                const curr = currentPage.current - 1;
                setCurrentPage({ current: curr });
              }}
            >
              <i className="fa-solid fa-arrow-right" />
            </Button>
            <Button
              type="primary"
              className={Classes.nextBtn}
              shape="circle"
              size="large"
              onClick={() => {
                const curr = currentPage.current + 1;
                setCurrentPage({ current: curr });
              }}
            >
              <i className="fa-solid fa-arrow-left" />
            </Button>
          </Row>
          <Form
            layout={window.innerWidth > 725 ? "inline" : "horizontal"}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            name="payment"
            onFinish={(values) => {
              console.log(values);
            }}
            onFinishFailed={() => {
              Modal.error({
                title: "خطا",
                content: "مشکلی هنگام انجام عملیات رخداد",
              });
            }}
          >
            <Widget>
              <FormItem label="تاریخ" className={"dateInput"}>
                <PersianDatePicker ref={dateRef} />
              </FormItem>
            </Widget>
            <Row>
              <Form.List name="payments">
                {(fields, { add, remove }) => {
                  return (
                    <div style={{ overflowY: "auto" }}>
                      {fields.map((field, index) => (
                        <Col lg={24} md={24} sm={24}>
                          <NewPayment
                            field={field}
                            fields={fields}
                            remove={remove}
                          />
                        </Col>
                      ))}
                      <Button
                        type="dashed"
                        htmlType="submit"
                        onClick={() => {
                          add();
                        }}
                        style={{ width: "100%", marginBottom: "50px" }}
                      >
                        <PlusOutlined /> افزودن فیلد
                      </Button>
                    </div>
                  );
                }}
              </Form.List>
            </Row>
          </Form>
        </>
      ),
    },
    {
      key: 3,
      title: "آخر",
      content: "محتوای نهایی",
    },
  ];
  return (
    <>
      <>
        <Steps
          direction="horizontal"
          style={{ flexDirection: "row" }}
          {...currentPage}
        >
          {steps.map((item) => (
            <Step key={item.title} />
          ))}
        </Steps>
        <div className="steps-content">
          {steps[currentPage.current].content}
        </div>
        <div className="steps-action">
          {currentPage.current === steps.length - 1 && (
            <Button
              type="primary"
              onClick={() => message.success("Processing complete!")}
            >
              تکمیل
            </Button>
          )}
        </div>
      </>
    </>
  );
}
